/*! jck-vsl-video-fix · 2026-07-09b */
(function(){if(window.__jckVslGuard)return;window.__jckVslGuard=!0;var BOTTOM_SRC="4397fcc8070d4d9f91e1fcbff3a10917";function isBottomVideo(el){if(!el||el.tagName!=="VIDEO")return!1;if(el.closest&&el.closest(".jck-bottom-vsl")||el.classList&&el.classList.contains("jck-bottom-video"))return!0;for(var src=(el.currentSrc||el.src||"")+"",sources=el.querySelectorAll("source"),i=0;i<sources.length;i++)src+=sources[i].getAttribute("src")||"";return src.indexOf(BOTTOM_SRC)!==-1}function cleanBottomSource(el){if(isBottomVideo(el)){el.querySelectorAll("source").forEach(function(s){var u=s.getAttribute("src")||"";u.indexOf("#")!==-1&&s.setAttribute("src",u.split("#")[0])});var direct=el.getAttribute("src")||"";direct.indexOf("#")!==-1&&el.setAttribute("src",direct.split("#")[0]),el.dataset.jckNoSeek="1",el.dataset.jckBottomExempt="1"}}function patchQuerySelectorAll(proto){var orig=proto.querySelectorAll;proto.querySelectorAll=function(sel){var list=orig.call(this,sel);return!sel||typeof sel!="string"||sel.indexOf("video")===-1?list:{length:list.length,item:function(i){return list[i]},forEach:function(fn){for(var i=0;i<list.length;i++){var el=list[i];el&&el.tagName==="VIDEO"&&cleanBottomSource(el),isBottomVideo(el)||fn(el,i,list)}}}}}patchQuerySelectorAll(Document.prototype),patchQuerySelectorAll(Element.prototype);var _ael=HTMLVideoElement.prototype.addEventListener;HTMLVideoElement.prototype.addEventListener=function(type,listener,options){if(isBottomVideo(this)&&(type==="seeking"||type==="seeked"||type==="timeupdate"||type==="ratechange"||type==="webkitpresentationmodechanged"))return;return _ael.call(this,type,listener,options)};function scanVideos(){document.querySelectorAll("video").forEach(cleanBottomSource)}document.documentElement?(scanVideos(),new MutationObserver(scanVideos).observe(document.documentElement,{childList:!0,subtree:!0})):document.addEventListener("DOMContentLoaded",scanVideos)})();
(function () {
  if (window.__jckVslVideoFix) return;
  window.__jckVslVideoFix = true;
  window.__jckVslVideoFixVer = "20260709c";

  var BOTTOM_SRC = "4397fcc8070d4d9f91e1fcbff3a10917";
  var BOTTOM_MP4 =
    "https://cdn.shopify.com/videos/c/o/v/4397fcc8070d4d9f91e1fcbff3a10917.mp4";

  function isBottomVideo(el) {
    if (!el || el.tagName !== "VIDEO") return false;
    if (el.closest && el.closest(".jck-bottom-vsl")) return true;
    if (el.classList && el.classList.contains("jck-bottom-video")) return true;
    var src = (el.currentSrc || el.src || "") + "";
    var sources = el.querySelectorAll("source");
    for (var i = 0; i < sources.length; i++) {
      src += sources[i].getAttribute("src") || "";
    }
    return src.indexOf(BOTTOM_SRC) !== -1;
  }

  function isVslPage() {
    var p = (location.pathname || "").toLowerCase();
    if (p.indexOf("jeff-hidden") !== -1) return true;
    if (p.indexOf("hidden-switch-vsl") !== -1) return true;
    return !!(
      document.getElementById("jcked-vsl") ||
      document.getElementById("jcked-lp") ||
      document.getElementById("jcked-vsl2")
    );
  }

  function hideFooter() {
    if (!isVslPage()) return;
    if (!document.getElementById("jck-vsl-hide-footer")) {
      var style = document.createElement("style");
      style.id = "jck-vsl-hide-footer";
      style.textContent =
        ".shopify-section-group-footer-group,footer.footer,[id^='shopify-section'][id*='footer']{display:none!important;}";
      document.head.appendChild(style);
    }
    document
      .querySelectorAll(
        ".shopify-section-group-footer-group,footer.footer,[id^='shopify-section'][id*='footer']"
      )
      .forEach(function (el) {
        el.style.display = "none";
      });
  }

  function findBottomVideo() {
    var byId = document.getElementById("jck-bottom-vsl-video");
    if (byId) return byId;
    var wrap = document.querySelector(".jck-bottom-vsl");
    if (wrap) {
      var v = wrap.querySelector("video");
      if (v) return v;
    }
    var videos = document.querySelectorAll("video");
    for (var i = 0; i < videos.length; i++) {
      if (isBottomVideo(videos[i])) return videos[i];
    }
    return null;
  }

  function resetBottomVideo(vid) {
    if (!vid || vid.dataset.jckBottomReset === "1") return vid;
    var wrap = vid.closest(".jck-bottom-vsl") || vid.parentElement;
    if (!wrap) return vid;

    var fresh = document.createElement("video");
    fresh.id = "jck-bottom-vsl-video";
    fresh.className = "vsl jck-bottom-video";
    fresh.setAttribute("playsinline", "");
    fresh.setAttribute("webkit-playsinline", "");
    fresh.setAttribute("preload", "metadata");
    fresh.style.cssText =
      vid.style.cssText ||
      "width:100%;height:auto;display:block;border-radius:16px;background:#1a1a1a;";
    fresh.innerHTML =
      '<source src="' + BOTTOM_MP4 + '" type="video/mp4">';
    fresh.dataset.jckBottomReset = "1";
    fresh.dataset.jckNoSeek = "1";
    fresh.dataset.jckBottomExempt = "1";
    fresh.controls = false;
    fresh.playsInline = true;

    var btn = wrap.querySelector(".jck-bottom-play");
    vid.parentNode.replaceChild(fresh, vid);
    if (btn) wrap.appendChild(btn);
    return fresh;
  }

  function ensureBottomPlay() {
    var vid = findBottomVideo();
    if (!vid) return;
    vid = resetBottomVideo(vid);
    if (vid.dataset.jckBottomWired === "1") return;
    vid.dataset.jckBottomWired = "1";

    var wrap = vid.closest(".jck-bottom-vsl") || vid.parentElement;
    if (!wrap) return;
    wrap.classList.add("jck-bottom-vsl");
    wrap.style.position = wrap.style.position || "relative";
    wrap.style.cursor = "pointer";

    var btn = wrap.querySelector(".jck-bottom-play");
    if (!btn) {
      btn = document.createElement("div");
      btn.className = "jck-bottom-play";
      btn.setAttribute("role", "button");
      btn.setAttribute("tabindex", "0");
      btn.setAttribute("aria-label", "Play video");
      btn.style.cssText =
        "position:absolute;inset:0;z-index:5;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.4);border-radius:16px;cursor:pointer;-webkit-tap-highlight-color:transparent;";
      btn.innerHTML =
        '<span style="width:74px;height:74px;border-radius:999px;background:#CE1126;display:flex;align-items:center;justify-content:center;box-shadow:0 10px 28px rgba(206,17,38,.45);pointer-events:none;"><svg width="28" height="28" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg></span>';
      wrap.appendChild(btn);
    }

    var activating = false;
    function hideBtn() {
      btn.style.display = "none";
    }
    function showBtn() {
      btn.style.display = "flex";
    }
    function startPlay() {
      vid.setAttribute("playsinline", "");
      vid.setAttribute("webkit-playsinline", "");
      vid.playsInline = true;
      vid.muted = true;
      vid.volume = 1;
      var p = vid.play();
      if (p && p.then) {
        p.then(function () {
          hideBtn();
          try {
            vid.muted = false;
            vid.volume = 1;
          } catch (e) {}
        }).catch(function () {
          showBtn();
        });
      } else {
        hideBtn();
      }
    }
    function onActivate(e) {
      if (activating) return;
      activating = true;
      setTimeout(function () {
        activating = false;
      }, 450);
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (vid.paused || vid.ended) {
        if (vid.ended) vid.currentTime = 0;
        startPlay();
      } else {
        vid.pause();
        showBtn();
      }
    }

    btn.addEventListener("pointerup", onActivate);
    btn.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") onActivate(e);
    });
    vid.addEventListener("play", hideBtn);
    vid.addEventListener("pause", function () {
      if (!vid.ended) showBtn();
    });
    vid.addEventListener("ended", showBtn);
  }

  function enhanceTopAudio() {
    var roots = [
      document.getElementById("jcked-vsl"),
      document.getElementById("jcked-lp"),
    ];
    roots.forEach(function (root) {
      if (!root || root.dataset.jckTopAudioWired) return;
      var vid = root.querySelector("video.vsl");
      if (!vid || isBottomVideo(vid)) return;

      root.dataset.jckTopAudioWired = "1";
      var soundBtn = root.querySelector(".vslsound");

      function showSoundBtn() {
        if (soundBtn) soundBtn.classList.remove("is-hidden");
      }
      function hideSoundBtn() {
        if (soundBtn) soundBtn.classList.add("is-hidden");
      }
      function enableSound() {
        vid.muted = false;
        vid.volume = 1;
        var p = vid.play();
        if (p && p.then) p.then(hideSoundBtn).catch(showSoundBtn);
        else hideSoundBtn();
        removeGestureListeners();
      }
      function onFirstGesture() {
        enableSound();
      }
      var gestureEvents = ["pointerdown", "touchstart", "click", "keydown", "scroll"];
      function addGestureListeners() {
        gestureEvents.forEach(function (ev) {
          window.addEventListener(ev, onFirstGesture, { once: true, passive: true });
        });
      }
      function removeGestureListeners() {
        gestureEvents.forEach(function (ev) {
          window.removeEventListener(ev, onFirstGesture, { passive: true });
        });
      }
      function tryUnmuteWhilePlaying() {
        try {
          vid.muted = false;
          vid.volume = 1;
          hideSoundBtn();
        } catch (e) {
          showSoundBtn();
          addGestureListeners();
        }
      }

      // Muted autoplay first (required on desktop + mobile), then unmute while playing.
      vid.setAttribute("autoplay", "");
      vid.setAttribute("muted", "");
      vid.setAttribute("loop", "");
      vid.setAttribute("playsinline", "");
      vid.muted = true;
      vid.loop = true;
      vid.playsInline = true;

      function beginPlayback() {
        if (!vid.paused && !vid.ended) return;
        var p = vid.play();
        if (p && p.then) {
          p.then(function () {
            tryUnmuteWhilePlaying();
          }).catch(function () {
            vid.muted = true;
            vid.play()
              .then(function () {
                tryUnmuteWhilePlaying();
              })
              .catch(function () {
                showSoundBtn();
                addGestureListeners();
              });
          });
        } else {
          tryUnmuteWhilePlaying();
        }
      }

      beginPlayback();
      vid.addEventListener("loadeddata", beginPlayback, { once: true });
      vid.addEventListener("canplay", beginPlayback, { once: true });

      if (soundBtn) {
        soundBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          enableSound();
        });
      }
      vid.addEventListener("volumechange", function () {
        if (vid.muted || vid.volume === 0) showSoundBtn();
        else hideSoundBtn();
      });
    });
  }

  function run() {
    hideFooter();
    ensureBottomPlay();
    enhanceTopAudio();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  var n = 0;
  var iv = setInterval(function () {
    run();
    if (++n > 40) clearInterval(iv);
  }, 300);
})();
